import { render } from "./ScoreDist.vue?vue&type=template&id=29d862a4&ts=true"
import script from "./ScoreDist.vue?vue&type=script&lang=ts"
export * from "./ScoreDist.vue?vue&type=script&lang=ts"

import "./ScoreDist.vue?vue&type=style&index=0&id=29d862a4&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__